import "./index.scss";
import React, { useEffect, useLayoutEffect, useState } from "react";

import AppButton from "../../../components/appButton";
import { showErrorToaster } from "../../../components/toaster/error";

import DataTableDisplay from "../../../components/tableMission";
import { useNavigate } from "react-router-dom";

import PaiementService from "../../../services/paiement/paiement.service";
import ReactPaginate from "react-paginate";
import PaiementsResponsiveCards from "../paiementsCardResponsive";
const paiementService = new PaiementService();

function PaiementListe() {
  const [paiements, setPaiement] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);
  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await paiementService?.getAllPaiement();
      setPaiement(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const columnsPaiements = [
    {
      name: "Transaction id",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.transaction_id != null && row?.transaction_id}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Montant",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.amount != null && row?.amount}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => (
        <div className="table-text">
          {row?.created_at != null && row?.created_at}
        </div>
      ),
      hide: "md",
      sortable: true,
    },

    {
      name: "Email",
      selector: (row) => (
        <div className="table-text">{row?.email != null && row?.email}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Nom et Prénom",
      selector: (row) => (
        <div className="table-text">
          {row?.nom != null && row?.nom} {row?.prenom != null && row?.prenom}
        </div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Téléphone",
      selector: (row) => (
        <div className="table-text">
          {row?.telephone != null && row?.telephone}
        </div>
      ),
      hide: "md",
      sortable: true,
    },

    {
      name: "Pays",
      selector: (row) => (
        <div className="table-text">{row?.pays != null && row?.pays}</div>
      ),
      hide: "md",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          style={{
            padding: "1rem",
          }}
        >
          <span
            style={{
              padding: "5px 10px",
              borderRadius: "12px",
              color: row?.status === "COMPLETED" ? "#00AC0E" : "#EE0202",
              backgroundColor:
                row?.status === "COMPLETED" ? "#D2FFD6" : "#FFD8D8",
            }}
          >
            {row?.status != null && row?.status}
          </span>
        </div>
      ),
      center: true,
      sortable: true,
    },
  ];
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3; // Adjust this number as needed

  // Calculate the offset
  const offset = currentPage * itemsPerPage;

  // Slice the missions list based on the current page and items per page
  const currentMissions = paiements.slice(offset, offset + itemsPerPage);

  // Handle page change
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  return (
    <section className="usersPage">
      <div className="container-fluid">
        <div className="row  my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3>Paiements liste</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex  my-0 my-md-5 justify-content-center align-items-center"></div>
        ) : (
          <div className=" my-0 my-md-5 py-2">
            {isMobile > 599 ? (
              <DataTableDisplay columns={columnsPaiements} data={paiements} />
            ) : (
              <>
                {paiements.map((item) => (
                  <PaiementsResponsiveCards
                    key={item.id} // Ensure the key is unique for each item
                    paiements={item}
                    loadData={loadData}
                  />
                ))}
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={Math.ceil(paiements.length / itemsPerPage)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default PaiementListe;
